import {Component, OnInit} from '@angular/core';
import {ModalComponent} from 'app/core/modal.component';
import {FormControl} from '@angular/forms';
import {Group} from '../../../../../../../chat-sdk/src/entities/groups/group';

@Component({
  selector: 'app-chat-edit-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatEditModalComponent extends ModalComponent implements OnInit {

  group: Group;

  chatName = new FormControl('');

  // @todo redo with form constructor, with all behavior
  ngOnInit() {
    this.chatName.setValue(this.group.content.title);
  }

  saveAndClose() {
    this.group.edit({
      title: this.chatName.value
    });

    this.closeModal();
  }
}


